import React from 'react';

import Icon from '../Icon/Icon';

const PersonalizeNBI = (props) => {
    return (
        <Icon width='32' height='32' fill='none' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 8.75C12.4142 8.75 12.75 9.08579 12.75 9.5V23.25C12.75 23.6642 12.4142 24 12 24C11.5858 24 11.25 23.6642 11.25 23.25V9.5C11.25 9.08579 11.5858 8.75 12 8.75Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.5 8.75C16.9142 8.75 17.25 9.08579 17.25 9.5V23.25C17.25 23.6642 16.9142 24 16.5 24C16.0858 24 15.75 23.6642 15.75 23.25V9.5C15.75 9.08579 16.0858 8.75 16.5 8.75Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21 8.75C21.4142 8.75 21.75 9.08579 21.75 9.5V23.25C21.75 23.6642 21.4142 24 21 24C20.5858 24 20.25 23.6642 20.25 23.25V9.5C20.25 9.08579 20.5858 8.75 21 8.75Z'
                fill='#393E44'
            />
            <path
                d='M14 19.5C14 20.6046 13.1046 21.5 12 21.5C10.8954 21.5 10 20.6046 10 19.5C10 18.3954 10.8954 17.5 12 17.5C13.1046 17.5 14 18.3954 14 19.5Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12 18C11.1716 18 10.5 18.6716 10.5 19.5C10.5 20.3284 11.1716 21 12 21C12.8284 21 13.5 20.3284 13.5 19.5C13.5 18.6716 12.8284 18 12 18ZM9.5 19.5C9.5 18.1193 10.6193 17 12 17C13.3807 17 14.5 18.1193 14.5 19.5C14.5 20.8807 13.3807 22 12 22C10.6193 22 9.5 20.8807 9.5 19.5Z'
                fill='#393E44'
            />
            <path
                d='M23 10.5C23 11.6046 22.1046 12.5 21 12.5C19.8954 12.5 19 11.6046 19 10.5C19 9.39543 19.8954 8.5 21 8.5C22.1046 8.5 23 9.39543 23 10.5Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M21 9C20.1716 9 19.5 9.67157 19.5 10.5C19.5 11.3284 20.1716 12 21 12C21.8284 12 22.5 11.3284 22.5 10.5C22.5 9.67157 21.8284 9 21 9ZM18.5 10.5C18.5 9.11929 19.6193 8 21 8C22.3807 8 23.5 9.11929 23.5 10.5C23.5 11.8807 22.3807 13 21 13C19.6193 13 18.5 11.8807 18.5 10.5Z'
                fill='#393E44'
            />
            <path
                d='M18.5 15C18.5 16.1046 17.6046 17 16.5 17C15.3954 17 14.5 16.1046 14.5 15C14.5 13.8954 15.3954 13 16.5 13C17.6046 13 18.5 13.8954 18.5 15Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.5 13.5C15.6716 13.5 15 14.1716 15 15C15 15.8284 15.6716 16.5 16.5 16.5C17.3284 16.5 18 15.8284 18 15C18 14.1716 17.3284 13.5 16.5 13.5ZM14 15C14 13.6193 15.1193 12.5 16.5 12.5C17.8807 12.5 19 13.6193 19 15C19 16.3807 17.8807 17.5 16.5 17.5C15.1193 17.5 14 16.3807 14 15Z'
                fill='#393E44'
            />
        </Icon>
    );
};

export default PersonalizeNBI;
